import { useState, useEffect, useRef } from "react";
import { CONST } from "../config/const";

// jotai
import { useAtom, useSetAtom, useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

// api
import {
  postEntryNoUsePayment,
  postEntryJPayment,
  postEntrySBPayment,
} from "../api/entry";
import { postCancell } from "../api/cancell";
import { postHashValue } from "../api/hashValue";
import {
  getPresignedPostPicture,
  postPresignedPost,
} from "../api/presignedURL";

const useLatest = (value: any) => {
  const ref = useRef(value);
  ref.current = value;
  return ref;
};

export const JPaymentSubmitBottom = (props: {
  submit_text: string;
  disabled: boolean;
  selectPullDownPlan: string;
  selectCheckBoxPlans: string[];
  formData: { [key: string]: string | string[] };
  postPictures: {
    [key: string]: File;
  };
  serviceValues: number;
  serviceTaxs: number;
  formTel: string;
  formEMail: string;
}) => {
  const {
    submit_text,
    disabled,
    selectPullDownPlan,
    selectCheckBoxPlans,
    formData,
    postPictures,
    serviceValues,
    serviceTaxs,
    formTel,
    formEMail,
  } = props;
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const setLayoutStatus = useSetAtom(AppAtoms.layoutStatus);
  const display = useAtomValue(AppAtoms.display);
  const inputID = useAtomValue(AppAtoms.inputID);
  const pathname = useAtomValue(AppAtoms.pathname);
  const options = useAtomValue(AppAtoms.options);
  const selectServices = [selectPullDownPlan, ...selectCheckBoxPlans];

  const apiKey = useAtomValue(AppAtoms.apiKey);
  const layoutConfig = useAtomValue(AppAtoms.layoutConfig);

  // 無料期間がない場合は、初回決済時に料金を指定
  // 初回決済料金　→　am
  // 初回決済税金　→　tx

  // 決済用のフォームデータ作成
  const [paymentFormDataNoTrial, setPaymentFormDataNoTrial] = useState({
    aid: String(131401),
    am:
      layoutConfig.trial_period_months === "特に表示なし（登録月から課金開始）"
        ? String(serviceValues)
        : String(0),
    tx:
      layoutConfig.trial_period_months === "特に表示なし（登録月から課金開始）"
        ? String(serviceTaxs)
        : String(0),
    sf: String(0),
    jb: "CAPTURE",
    pn: String(formTel),
    em: String(formEMail),
    actp: String(4),
    acam: String(serviceValues),
    actx: String(serviceTaxs),
    acsf: String(0),
    ac1: String(1),
    inm: layoutConfig.site_title,
    key: apiKey,
    paymentType: "j-payment",
    display: display,
    pathname: pathname,
  });
  const [paymentFormData, setPaymentFormData] = useState({
    aid: String(131401),
    am: String(0),
    tx: String(0),
    sf: String(0),
    jb: "CAPTURE",
    pn: String(formTel),
    em: String(formEMail),
    actp: String(4),
    acam: String(serviceValues),
    actx: String(serviceTaxs),
    acsf: String(0),
    ac1: String(1),
    trtp: String(4),
    tr2: String(
      layoutConfig.trial_period_months === "特に表示なし（登録月から課金開始）"
        ? "0"
        : layoutConfig.trial_period_months === "１か月間無料"
        ? "0"
        : layoutConfig.trial_period_months === "２か月間無料"
        ? "1"
        : layoutConfig.trial_period_months === "３か月間無料"
        ? "2"
        : layoutConfig.trial_period_months === "４か月間無料"
        ? "3"
        : layoutConfig.trial_period_months === "５か月間無料"
        ? "4"
        : layoutConfig.trial_period_months === "６か月間無料"
        ? "5"
        : "0"
    ),
    tram: String(0),
    trtx: String(0),
    trsf: String(0),
    inm: layoutConfig.site_title,
    key: apiKey,
    paymentType: "j-payment",
    display: display,
    pathname: pathname,
  });
  useEffect(() => {
    setPaymentFormDataNoTrial({
      ...paymentFormDataNoTrial,
      am:
        layoutConfig.trial_period_months ===
        "特に表示なし（登録月から課金開始）"
          ? String(serviceValues)
          : String(0),
      tx:
        layoutConfig.trial_period_months ===
        "特に表示なし（登録月から課金開始）"
          ? String(serviceTaxs)
          : String(0),
      pn: String(formTel),
      em: String(formEMail),
      acam: String(serviceValues),
      actx: String(serviceTaxs),
      inm: layoutConfig.site_title,
      key: apiKey,
      display: display,
      pathname: pathname,
    });
    setPaymentFormData({
      ...paymentFormData,
      am: String(0),
      tx: String(0),
      pn: String(formTel),
      em: String(formEMail),
      acam: String(serviceValues),
      actx: String(serviceTaxs),
      tr2: String(
        layoutConfig.trial_period_months ===
          "特に表示なし（登録月から課金開始）"
          ? "0"
          : layoutConfig.trial_period_months === "１か月間無料"
          ? "0"
          : layoutConfig.trial_period_months === "２か月間無料"
          ? "1"
          : layoutConfig.trial_period_months === "３か月間無料"
          ? "2"
          : layoutConfig.trial_period_months === "４か月間無料"
          ? "3"
          : layoutConfig.trial_period_months === "５か月間無料"
          ? "4"
          : layoutConfig.trial_period_months === "６か月間無料"
          ? "5"
          : "0"
      ),
      inm: layoutConfig.site_title,
      key: apiKey,
      display: display,
      pathname: pathname,
    });
  }, [
    formTel,
    formEMail,
    serviceValues,
    serviceTaxs,
    layoutConfig,
    display,
    pathname,
  ]);
  const handleSubmit = async () => {
    setIsLoading(true);
    let customerInfo = { ...formData };
    // 画像データがある場合は事前に格納
    await Promise.all(
      options.map(async (option) => {
        if (
          option.option_type === 4 &&
          postPictures[option.option_name as string]
        ) {
          const postPicture = postPictures[option.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(display, nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const pictureFormData = new FormData();
          for (const key in presigned_object.fields) {
            pictureFormData.append(key, presigned_object.fields[key]);
          }
          pictureFormData.append("file", postPicture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, pictureFormData);
          customerInfo[option.option_name as string] = destination_key;
        }
      })
    );
    const { result, contract_number } = await postEntryJPayment(
      display,
      pathname,
      selectServices,
      customerInfo,
      inputID,
      serviceValues,
      serviceTaxs
    );
    if (result == "success") {
      const form = document.createElement("form");
      form.method = "POST";
      form.action = "https://credit.j-payment.co.jp/link/creditcard";
      if (
        layoutConfig.trial_period_months ===
          "特に表示なし（登録月から課金開始）" ||
        layoutConfig.trial_period_months === "１か月間無料"
      ) {
        Object.entries(paymentFormDataNoTrial).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });
      } else {
        Object.entries(paymentFormData).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });
      }

      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "contract_number";
      input.value = contract_number;
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();
    } else if (result == "duplicate") {
      setLayoutStatus("entry_duplicate");
      setIsLoading(false);
    } else if (result == "error") {
      setLayoutStatus("entry_error");
      setIsLoading(false);
    }
  };
  return (
    <input
      className="wpcf7-form-control wpcf7-submit has-spinner submit"
      type="submit"
      value={submit_text}
      disabled={disabled}
      onClick={handleSubmit}
    />
  );
};

export const SBPaymentSubmitBottom = (props: {
  submit_text: string;
  disabled: boolean;
  selectPullDownPlan: string;
  selectCheckBoxPlans: string[];
  formData: { [key: string]: string | string[] };
  postPictures: {
    [key: string]: File;
  };
  serviceValues: number;
  serviceTaxs: number;
  pay_method: string;
}) => {
  const {
    submit_text,
    disabled,
    selectPullDownPlan,
    selectCheckBoxPlans,
    formData,
    postPictures,
    serviceValues,
    serviceTaxs,
    pay_method,
  } = props;
  const [isLoading, setIsLoading] = useAtom(AppAtoms.isLoading);
  const lastIsLoading = useLatest(isLoading);
  const setLayoutStatus = useSetAtom(AppAtoms.layoutStatus);
  const display = useAtomValue(AppAtoms.display);
  const inputID = useAtomValue(AppAtoms.inputID);
  const pathname = useAtomValue(AppAtoms.pathname);
  const options = useAtomValue(AppAtoms.options);
  const selectServices = [selectPullDownPlan, ...selectCheckBoxPlans];

  const apiKey = useAtomValue(AppAtoms.apiKey);
  const layoutConfig = useAtomValue(AppAtoms.layoutConfig);

  // 無料期間がない場合は SBペイメントでは暫定的に対応不可

  // 決済用のフォームデータ作成
  const [paymentFormData, setPaymentFormData] = useState({
    pay_method: pay_method,
    merchant_id: "59284",
    service_id: "001",
    cust_code: "",
    order_id: "",
    item_id: "001",
    item_name: layoutConfig.site_title,
    service_type: "0",
    success_url: "",
    cancel_url: "",
    error_url: "",
    pagecon_url: "",
    request_date: "",
    sps_hashcode: "",
  });

  useEffect(() => {
    const success_url =
      CONST.apiUrl +
      "entrySBPaymentSuccess?key=" +
      apiKey +
      "&inputID=" +
      inputID +
      "&display=" +
      display +
      "&path=" +
      pathname;
    const cancel_url =
      CONST.apiUrl +
      "entrySBPaymentCancel?key=" +
      apiKey +
      "&inputID=" +
      inputID +
      "&display=" +
      display +
      "&path=" +
      pathname;
    const error_url =
      CONST.apiUrl +
      "entrySBPaymentError?key=" +
      apiKey +
      "&inputID=" +
      inputID +
      "&display=" +
      display +
      "&path=" +
      pathname;
    setPaymentFormData((paymentFormData) => ({
      ...paymentFormData,
      pay_method,
      item_name: layoutConfig.site_title,
      success_url,
      cancel_url,
      error_url,
    }));
  }, [apiKey, inputID, display, pathname, pay_method, layoutConfig]);

  useEffect(() => {
    const updateTime = () => {
      if (!lastIsLoading.current) {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const date = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        const request_date = `${year}${month}${date}${hours}${minutes}${seconds}`;
        setPaymentFormData((paymentFormData) => ({
          ...paymentFormData,
          request_date,
        }));
      }
    };

    updateTime();
    const intervalId = setInterval(updateTime, 1000); // 1秒ごとに更新

    return () => clearInterval(intervalId); // コンポーネントのアンマウント時にクリーンアップ
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    let customerInfo = { ...formData };
    // 画像データがある場合は事前に格納
    await Promise.all(
      options.map(async (option) => {
        if (
          option.option_type === 4 &&
          postPictures[option.option_name as string]
        ) {
          const postPicture = postPictures[option.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(display, nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const pictureFormData = new FormData();
          for (const key in presigned_object.fields) {
            pictureFormData.append(key, presigned_object.fields[key]);
          }
          pictureFormData.append("file", postPicture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, pictureFormData);
          customerInfo[option.option_name as string] = destination_key;
        }
      })
    );
    // エントリー情報登録
    const { result, contract_number } = await postEntrySBPayment(
      display,
      pathname,
      selectServices,
      customerInfo,
      inputID,
      serviceValues,
      serviceTaxs
    );
    if (result == "success") {
      const trialPeriodMonth =
        layoutConfig.trial_period_months ===
        "特に表示なし（登録月から課金開始）"
          ? "0month"
          : layoutConfig.trial_period_months === "１か月間無料"
          ? "1month"
          : layoutConfig.trial_period_months === "２か月間無料"
          ? "2month"
          : layoutConfig.trial_period_months === "３か月間無料"
          ? "3month"
          : layoutConfig.trial_period_months === "４か月間無料"
          ? "4month"
          : layoutConfig.trial_period_months === "５か月間無料"
          ? "5month"
          : layoutConfig.trial_period_months === "６か月間無料"
          ? "6month"
          : "0month";
      // 申込番号を用いてフォームデータ更新
      let _paymentFormData = paymentFormData;
      const pagecon_url =
        CONST.apiUrl +
        "entrySBPaymentPagecon?key=" +
        apiKey +
        "&inputID=" +
        inputID +
        "&display=" +
        display +
        "&path=" +
        pathname +
        "&contractNumber=" +
        contract_number +
        "&trialPeriod=" +
        trialPeriodMonth +
        "&serviceValues=" +
        serviceValues +
        "&serviceTaxs=" +
        serviceTaxs +
        "&pay_method=" +
        paymentFormData.pay_method;
      _paymentFormData["pagecon_url"] = pagecon_url;

      const cust_code = contract_number;
      _paymentFormData["cust_code"] = cust_code;
      const order_id = `order-${contract_number}`;
      _paymentFormData["order_id"] = order_id;

      const hashValue = await postHashValue(_paymentFormData);
      _paymentFormData["sps_hashcode"] = hashValue;

      const form = document.createElement("form");
      form.method = "POST";
      form.action = CONST.sbPaymentURL;
      form.acceptCharset = "Shift_JIS";
      Object.entries(_paymentFormData).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    } else if (result == "duplicate") {
      setLayoutStatus("entry_duplicate");
      setIsLoading(false);
    } else if (result == "error") {
      setLayoutStatus("entry_error");
      setIsLoading(false);
    }
  };
  return (
    <input
      className="wpcf7-form-control wpcf7-submit has-spinner submit"
      type="submit"
      value={submit_text}
      disabled={disabled || paymentFormData.request_date == ""}
      onClick={handleSubmit}
    />
  );
};

export const DummySubmitBottom = (props: { submit_text: string }) => {
  const { submit_text } = props;
  return (
    <>
      <input
        className="wpcf7-form-control wpcf7-submit has-spinner submit"
        type="submit"
        value={submit_text}
        disabled={true}
      />
    </>
  );
};

export const SubmitBottom = (props: {
  submit_text: string;
  disabled: boolean;
  selectPullDownPlan: string;
  selectCheckBoxPlans: string[];
  formData: { [key: string]: string | string[] };
  postPictures: {
    [key: string]: File;
  };
  serviceValues: number;
  serviceTaxs: number;
}) => {
  const {
    submit_text,
    disabled,
    selectPullDownPlan,
    selectCheckBoxPlans,
    formData,
    postPictures,
    serviceValues,
    serviceTaxs,
  } = props;
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const setLayoutStatus = useSetAtom(AppAtoms.layoutStatus);
  const display = useAtomValue(AppAtoms.display);
  const inputID = useAtomValue(AppAtoms.inputID);
  const pathname = useAtomValue(AppAtoms.pathname);
  const options = useAtomValue(AppAtoms.options);

  const selectServices = [selectPullDownPlan, ...selectCheckBoxPlans];

  const handleSubmit = async () => {
    setIsLoading(true);
    let customerInfo = { ...formData };
    // 画像データがある場合は事前に格納
    await Promise.all(
      options.map(async (option) => {
        if (
          option.option_type === 4 &&
          postPictures[option.option_name as string]
        ) {
          const postPicture = postPictures[option.option_name as string];
          // 著名付きURL(post用)を作成
          const fileName = postPicture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(display, nowTimeName, fileName);

          // POSTする form に持たせるデータを生成する
          const pictureFormData = new FormData();
          for (const key in presigned_object.fields) {
            pictureFormData.append(key, presigned_object.fields[key]);
          }
          pictureFormData.append("file", postPicture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, pictureFormData);
          customerInfo[option.option_name as string] = destination_key;
        }
      })
    );
    // エントリー情報登録
    const { result, contract_number } = await postEntryNoUsePayment(
      display,
      pathname,
      selectServices,
      customerInfo,
      inputID,
      serviceValues,
      serviceTaxs
    );
    if (result == "success") {
      setLayoutStatus("entry_success");
    } else if (result == "duplicate") {
      setLayoutStatus("entry_duplicate");
    } else if (result == "error") {
      setLayoutStatus("entry_error");
    }
    setIsLoading(false);
  };

  return (
    <>
      <input
        className="wpcf7-form-control wpcf7-submit has-spinner submit"
        type="submit"
        value={submit_text}
        disabled={disabled}
        onClick={handleSubmit}
      />
    </>
  );
};

export const CancellSubmitBottom = (props: {
  submit_text: string;
  formData: { [key: string]: string | string[] };
  disabled: boolean;
}) => {
  const { submit_text, formData, disabled } = props;
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const setLayoutStatus = useSetAtom(AppAtoms.layoutStatus);
  const display = useAtomValue(AppAtoms.display);
  const pathname = useAtomValue(AppAtoms.pathname);

  const handleSubmit = async () => {
    setIsLoading(true);
    const result = await postCancell(display, pathname, formData);
    if (result == "success") {
      setLayoutStatus("cancell_success");
    } else {
      setLayoutStatus("cancell_error");
    }
    setIsLoading(false);
  };
  return (
    <>
      <input
        className="wpcf7-form-control wpcf7-submit has-spinner submit"
        type="submit"
        value={submit_text}
        disabled={disabled}
        onClick={handleSubmit}
      />
    </>
  );
};
